import { ExternalLessonContextProvider } from '../dashboard/models/ExternalLessonContext';
import { IExternalToolComponentProps } from './ExternalTool';
import { LessonPortfolioComponent } from '../dashboard/components/LessonPortfolioComponent';
import React from 'react';
import { useParams } from 'react-router-dom';

/** Properties passed to the external tool lesson component. */
export interface IExternalToolLessonProps extends IExternalToolComponentProps {}

/**
 * Component to render a lesson using only authenticated user and lesson key.
 */
const ExternalToolLesson = (props: IExternalToolLessonProps) => {
  const { lessonkey: lessonkeyStr } = useParams<{ lessonkey: string }>();
  const lessonkey = +lessonkeyStr;
  return (
    <ExternalLessonContextProvider value={{ isExternalLesson: true }}>
      <LessonPortfolioComponent lessonkey={lessonkey} {...props} />
    </ExternalLessonContextProvider>
  );
};

export default ExternalToolLesson;
